import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITransportConfigurationService } from './i-transport-configuration.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';

import { IInsuranceTransporterConfiguration } from '../models/insurance-transporter.configuration';

@Injectable({ providedIn: 'root' })
export class InsuranceTransporterConfigurationService implements ITransportConfigurationService<IInsuranceTransporterConfiguration> {
  public publicResourceUrl = API_ENDPOINTS.TRANSPORTER_CONFIGURATION;
  public moderatorResourceUrl = API_ENDPOINTS.MODERATOR_TRANSPORTER_CONFIGURATION;

  constructor(protected apiProvider: ApiProviderService) {}

  retrieveConfiguration(transporterId?: number): Observable<HttpResponse<IInsuranceTransporterConfiguration>> {
    return this.apiProvider.publicGet<IInsuranceTransporterConfiguration>(this.publicResourceUrl('insurance', transporterId), { observe: 'response' });
  }

  updateConfiguration(configuration: IInsuranceTransporterConfiguration, transporterId?: number): Observable<HttpResponse<IInsuranceTransporterConfiguration>> {
    return this.apiProvider.configurationPut<IInsuranceTransporterConfiguration>(this.moderatorResourceUrl('insurance', transporterId), configuration);
  }
}
